import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Lots', 'Codes'] });

const apiLotsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getRootLots: builder.query({
      query: ({ ean, opk, page, ordering, psize }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots`,
        params: {
          page,
          ordering,
          psize,
        },
      }),
      providesTags: ['Lots'],
    }),
    addLot: builder.mutation({
      query: ({ payload, ean, opk }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Lots'],
    }),
    getSingleLot: builder.query({
      query: ({ ean, opk, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${id}`,
      }),
      providesTags: ['Lots'],
    }),
    modifySingleLot: builder.mutation({
      query: ({ payload, ean, opk, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Lots'],
    }),
    deleteSingleLot: builder.mutation({
      query: ({ ean, opk, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${id}`,
        method: 'DELETE',
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Lots'],
    }),
    getChildrensLot: builder.query({
      query: ({ ean, opk, id, page, ordering, psize }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${id}/children`,
        params: {
          page,
          ordering,
          psize,
        },
      }),
      providesTags: ['Lots'],
    }),
    addChildrenToLot: builder.mutation({
      query: ({ payload, ean, opk, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${id}/children`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Lots'],
    }),
    addCodesToLot: builder.mutation({
      query: ({ payload, ean, opk, lpk, amount }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${lpk}/create_codes/${amount}`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Codes'],
    }),
    getCodesLot: builder.query({
      query: ({ ean, opk, lpk, ordering, page, psize, suspect, used }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${lpk}/codes`,
        params: {
          ordering,
          page,
          psize,
          suspect,
          used,
        },
      }),
      providesTags: ['Codes'],
    }),
    modifyCodeLot: builder.mutation({
      query: ({ payload, ean, opk, lpk, id }) => ({
        url: `/community/organizations/${opk}/products/${ean}/lots/${lpk}/codes/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Codes'],
    }),
    scanCodeCount: builder.query({
      query: ({ ean, code }) => ({
        url: `/community/products/${ean}/scan_code_count/${code}`,
        method: 'GET',
      }),
      providesTags: ['Codes'],
    }),
    verifyCode: builder.query({
      query: ({ ean, code }) => ({
        url: `/community/products/${ean}/verify_code/${code}`,
        method: 'GET',
      }),
      providesTags: ['Codes'],
      keepUnusedDataFor: 0,
    }),
    verifyLot: builder.query({
      query: ({ ean, aut, lotCode, ordering, page, psize }) => ({
        url: `/community/products/${ean}/verify_lot/${aut}/${lotCode}`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['Lots'],
    }),
  }),
});

export const {
  useGetRootLotsQuery,
  useAddLotMutation,
  useGetSingleLotQuery,
  useModifySingleLotMutation,
  useDeleteSingleLotMutation,
  useGetChildrensLotQuery,
  useAddChildrenToLotMutation,
  useAddCodesToLotMutation,
  useGetCodesLotQuery,
  useModifyCodeLotMutation,
  useScanCodeCountQuery,
  useVerifyCodeQuery,
  useVerifyLotQuery,
} = apiLotsSlice;

export default apiLotsSlice;
